import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS, CODIGO_CENTRUS_RECUPERAR_SENHA, INFORMACOES_RECUPERAR_SENHA, TOKEN_PADRAO } from '../../../app.constants';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';
import { throttle } from '../../shared/decorators/throttle';
import { AlterarSenhaModel } from '../../shared/dominios/alterar-senha.model';
import { TipoCdCentrusRecebido } from '../../shared/dominios/tipo-cdCentrus-recebido';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { ResToken } from '../../shared/models/res-token.modul';
import { UsuarioWebDTOModel } from '../../shared/models/usuarioWebDTO.model';
import { EnderecoCentrusService } from '../../shared/services/endereco-centrus.service';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { RecuperarSenhaService } from '../service/recuperar-senha.service';
import { LoginService } from './../../login/service/login.service';

@Component({
  selector: 'app-alteracao-senha',
  templateUrl: './alteracao-senha.component.html',
  styleUrls: ['./alteracao-senha.component.css']
})
export class AlteracaoSenhaComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;


  alterarSenhaOuPrimeiroAcesso = false;


  alterarSenhaModel = new AlterarSenhaModel();

  resToken = new ResToken();
  mostrarEsconderSenha = 'password';

  usuarioWebDTOModel = new UsuarioWebDTOModel();
  cdCentrus: number;

  sgSenha: string;
  confirmaSenha: string;


  tiposCentrus = new TipoCdCentrusRecebido()
  senhaMenorSeis = false;
  senhaComposicaoErrada = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private recoverPasswordService: RecuperarSenhaService,
    private enderecoCentrusService: EnderecoCentrusService,
    private toastrService: ToastrService,
    private authInterceptor: AuthInterceptor
  ) { }

  ngOnInit() {
    this._gerenciarCodigoIndentificao();

  }


  getDadosSesseionStorage(): Promise<TipoCdCentrusRecebido> {

    return new Promise((resolve, reject) => {
      const processoRecuperarSenha = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS_RECUPERAR_SENHA);
      const alterarSenhaQuandoLogado = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);

      this.tiposCentrus.alterarSenhaQuandoLogado = Number(alterarSenhaQuandoLogado);
      this.tiposCentrus.processoRecuperarSenha = Number(processoRecuperarSenha);
      resolve(this.tiposCentrus);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then((arg: TipoCdCentrusRecebido) => {

        if (arg.processoRecuperarSenha) {
          this.cdCentrus = arg.processoRecuperarSenha;
          return;
        } if (arg.alterarSenhaQuandoLogado) {
          this.cdCentrus = arg.alterarSenhaQuandoLogado;
          return;
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          return;
        }
      })
    this.pegandoDadosSessionStorage();
  }


  mostrarSenha() {
    (this.mostrarEsconderSenha === 'text')
      ? this.mostrarEsconderSenha = 'password'
      : this.mostrarEsconderSenha = 'text'
  }



  pegandoDadosSessionStorage() {


    if (localStorage.getItem(TOKEN_PADRAO)) { this.resToken.cdCentrus = Number(this.cdCentrus), this.alterarSenhaOuPrimeiroAcesso = false };

    const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(INFORMACOES_RECUPERAR_SENHA);

    if (recuperandoObjeto) {
      const paramentrosPesquisa = JSON.parse(recuperandoObjeto);
      this.resToken.cdCentrus = Number(paramentrosPesquisa['cdCentrus']);
      this.resToken.idTokenAcesso = Number(paramentrosPesquisa['idTokenAcesso']);
      this.resToken.dsTokenAcesso = paramentrosPesquisa['dsTokenAcesso'];
      this.resToken.dhInclusao = paramentrosPesquisa['dhInclusao'];
      this.resToken.dsEmail = paramentrosPesquisa['dsEmail'];
      this.resToken.noFuncao = paramentrosPesquisa['noFuncao'];
      this.alterarSenhaOuPrimeiroAcesso = false;
    }

  }

  @throttle()
  async sendPassword(alterarSenhaModel) {
    await this.loginService
      .loginGetToken()
      .then(async (token) => {
        await this.recoverPasswordService.newPassword(alterarSenhaModel.value, this.resToken.cdCentrus, token)
          .then(() => {
            this.updateSenhaUsuarioWeb(this.resToken.cdCentrus, alterarSenhaModel.value, token);
            (this.cdCentrus)
              ? (this.router.navigate(['/home']), StorafeUtil.limparSessionStorage(CODIGO_CENTRUS_RECUPERAR_SENHA))
              : (this.router.navigate(['/login']), StorafeUtil.limparSessionStorage(CODIGO_CENTRUS_RECUPERAR_SENHA))
            this.toastrService.success('Senha alterada com  sucesso.')
            // sessionStorage.clear();
          })
          .catch(() => this.toastrService.error(MessageUtil.TOKEN_FALHA))
          .catch(() => this.toastrService.error(MessageUtil.TOKEN_FALHA));
      })

  }

  voltar(): void {
    (this.cdCentrus)
      ? this.router.navigate(['/home'])
      : this.router.navigate(['recuperarSenha/codigoAcesso'], { skipLocationChange: true })
  }


  verificarCondicoes(sgSenha) {
    const verificarCaracteresObrigatorios = /(([a-z]+[A-Z]+|[A-Z]+[a-z]+)|([0-9]+[A-Za-z]+)|([a-zA-Z]+[0-9])+|([\W]))/;
    this.senhaMenorSeis = (sgSenha.length < 6) ? true : false;
    this.senhaComposicaoErrada = (!verificarCaracteresObrigatorios.test(sgSenha)) ? true : false;
  }


  updateSenhaUsuarioWeb(cdCentrus: number, sgSenha: string, token): void {


    // this.usuarioWebDTOModel.cdCentrus = cdCentrus.toString();
    // this.usuarioWebDTOModel.sgSenha = sgSenha['sgSenha'];

    this.enderecoCentrusService.updateSenhaUsuarioWeb(cdCentrus, (this.sgSenha) ? this.sgSenha : sgSenha['sgSenha'], token)
      .then().catch(error => console.log(error))
  }

}


// INFORMACOES_RECUPERAR_SENHA
// CODIGO_CENTRUS_RECUPERAR_SENHA



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/recuperar-senha/alteracao-senha/alteracao-senha.component.ts